import {
  ActiveCampaignIcon,
  DripIcon,
  FacebookIcon,
  GoogleIcon,
  KlaviyoIcon,
  MailChimpIcon,
  OmnisendIcon,
  PostscriptIcon,
  YotpoIcon,
} from 'components/icons';
import { ReactNode, useMemo } from 'react';

export const useProviderIcon = ({ provider }: { provider: string }) => {
  const ProviderIcon = useMemo(() => {
    const icons: Record<string, ReactNode> = {
      klaviyo: <KlaviyoIcon />,
      mailchimp: <MailChimpIcon />,
      activecampaign: <ActiveCampaignIcon />,
      facebook: <FacebookIcon />,
      drip: <DripIcon />,
      omnisend: <OmnisendIcon />,
      google: <GoogleIcon />,
      postscript: <PostscriptIcon />,
      yotpo: <YotpoIcon />,
    };

    return icons[provider.toLowerCase()];
  }, [provider]);

  return { ProviderIcon };
};
